import {
  Box,
  Checkbox,
  InputAdornment,
  ListItemText,
  makeStyles,
  Select,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import { lighten } from 'polished'
import { AdminContainer } from 'pages/administration/components/AdminContainer'

import { Search } from '@material-ui/icons'
import { CustomIconContextMenu } from 'components/core/actions-menu-noborder/CustomIconContextMenu'
import { ReactComponent as ActionContextIcon } from 'icons/action-context-icon.svg'
import { useAdminEventRegistrants } from 'pages/administration/hooks/event-list/useAdminEventRegistrants'
//@ts-ignore
import { useTheme } from 'styled-components'
import { EventMetrics } from './EventMetrics'
import {
  CustomMenuItem,
  CustomTableContainer,
  CustomTableRow,
  ResetButton,
  SearchInput,
  StyledDateBox,
  StyledFilterMenuIcon,
  StyledHeadTableCell,
  StyledIconButton,
  StyledTableCell,
  StyledTableCellStatus
} from './styled'
import { AttendanceType, EventAttendeeStatus } from 'common/types'
import { useEvents } from './hooks/useEvents'
import { useParams } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from 'components/core/loader'
import { Button } from 'common/atoms/Button/Button'

const EventRegistrantsPage = () => {
  const theme = useTheme()
  const useStyles = makeStyles(() => ({
    select: {
      width: '160px',
      minWidth: '0px !important',
      borderRadius: '5px !important'
    },
    custom: {
      border: 'none !important',
      borderRadius: '1px !important',
      '& .MuiSvgIcon-root': {
        color: theme.colors.primary,
        display: 'flex',
        top: '0.55em',
        right: '0.50em'
      }
    }
  }))

  const classes = useStyles()
  const { checkIn } = useEvents()
  const { eventId } = useParams<{ eventId: string }>()

  const getThemeForInput = () => {
    return mode === 'light' ? lighten(0.9, theme.colors.accent1) : theme.colors.accent1
  }


  const {
    searchCriteria,
    setSearchCriteria,
    showFilter,
    setShowFilter,
    statusValue,
    listHeadline,
    liveActionItems,
    statusList,
    mode,
    notify,
    attendeesList,
    registrantsTotalCount,
    eventRegistrantsPage,
    setEventRegistrantsPage,
    metrics
  } = useAdminEventRegistrants()



  const handleCheckIn = async (attendeeId: string) => {
    await checkIn(attendeeId, eventId)
    notify('success', 'check-in successful')
    setTimeout(function () {
      window.location.reload();
    }, 800);
  }

  const fetchMore = () => {
    setEventRegistrantsPage(eventRegistrantsPage + 1)
  }

  return (
    <AdminContainer title={''}>
      <Box display="flex" bgcolor={theme.colors.bgPrimary} width="100%" p="1em">
        <Box justifyContent="center" bgcolor={theme.colors.bgPrimary} width="100%">
          <Typography variant="h6">
            <Box color={theme.colors.accent1} fontWeight="bold">
              Registrants
            </Box>
          </Typography>
          <EventMetrics registrantsTotalCount={registrantsTotalCount} metrics={metrics} />
          <Box display="flex" alignItems="center" mb={1}>
            <Box
              bgcolor={theme.colors.supplementary}
              borderRadius="5.125em"
              margin="1em 1em 1em 0"
              height="2.5em"
            >
              <SearchInput
                type="search"
                onChange={(e: any) => {
                  setSearchCriteria(e?.target?.value)
                }}
                placeholder="Search..."
                value={searchCriteria}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    border: 'none',
                    color: getThemeForInput()
                  },
                  endAdornment: (
                    <InputAdornment position="start">
                      <Search color={theme.colors.accent} />
                    </InputAdornment>
                  )
                }}
              />
            </Box>
            <Box display="flex" alignItems="center" bgcolor={theme.colors.supplementary} borderRadius="5.125em">
              <Button
                design='secondary'
                startIcon={<StyledFilterMenuIcon />}
                onClick={() => setShowFilter(prevState => !prevState)}
              >
                Filter
              </Button>
            </Box>
            {showFilter && (
              <Box display="flex" marginLeft="1.8em">
                <StyledDateBox minWidth="13em">
                  <Box
                    bgcolor={theme.colors.supplementary}
                    borderRadius="5.125em"
                    margin="1.2em 2em 1em 0"
                    style={{ height: '2.7em' }}
                  >
                    <Select
                      MenuProps={{
                        classes: { paper: classes.select },
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left'
                        },
                        transformOrigin: {
                          vertical: 'top',
                          horizontal: 'left'
                        },
                        getContentAnchorEl: null
                      }}
                      fullWidth
                      multiple
                      disableUnderline
                      value={statusValue}
                      className={classes.custom}
                      onChange={() => { }}
                      renderValue={(selected: any) => selected?.join(', ')}
                      name="status"
                    >
                      {statusList?.map(name => (
                        <CustomMenuItem key={name} value={name}>
                          <Checkbox checked={statusValue?.indexOf(name) > -1} />
                          <ListItemText primary={name?.charAt(0)?.toUpperCase()?.concat(name?.slice(1))} />
                        </CustomMenuItem>
                      ))}
                    </Select>
                  </Box>
                </StyledDateBox>
                <Box mt="1.8em">
                  <Typography variant="body1">
                    <ResetButton color={theme.colors.accent}>
                      Reset
                    </ResetButton>
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
          <Box display="flex">
            <CustomTableContainer showFilter={showFilter}>
              <InfiniteScroll
                loader={<Loader />}
                hasMore={registrantsTotalCount > attendeesList?.length}
                endMessage={
                  <p style={{ textAlign: 'center', color: theme.colors.accent1 }}>
                    {attendeesList?.length === 0 ? <b>No Registrants</b> : <b>No More Registrants</b>}
                  </p>
                }
                next={() => {
                  fetchMore()
                }}
                dataLength={attendeesList?.length || 0}
                height={'60vh'}
              >
                <Table aria-label="simple table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      {listHeadline?.map(x =>
                        x === 'Status' ? (
                          <StyledHeadTableCell align="left">{x}</StyledHeadTableCell>
                        ) : (
                          <StyledHeadTableCell align="left">{x}</StyledHeadTableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {attendeesList?.map(row => (
                      <CustomTableRow>
                        <StyledTableCell align="left">
                          <Typography component="span" variant="body2">
                            <Box display="inline">
                              {row?.firstName?.slice(0, 35)} <br />
                              {row?.firstName?.slice(35, row?.firstName?.length)}
                            </Box>
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="left">{row?.lastName}</StyledTableCell>
                        <StyledTableCell align="left">{row?.username}</StyledTableCell>
                        <StyledTableCell>
                          <StyledTableCellStatus design='tertiary'>{row?.status}</StyledTableCellStatus>
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          <CustomIconContextMenu
                            title=""
                            menuWidth="13em"
                            disabled={
                              row?.status === EventAttendeeStatus.ATTENDED ||
                              row?.attendanceType?.toLowerCase() === AttendanceType.VIRTUAL.toLowerCase()
                            }
                            icon={<ActionContextIcon fill={theme.colors.accent1} />}
                          >
                            {row?.status === EventAttendeeStatus.REGISTERED &&
                              row?.attendanceType?.toLowerCase() !== AttendanceType.VIRTUAL.toLowerCase() &&
                              liveActionItems?.map(x => (
                                <StyledIconButton size="small" onClick={() => handleCheckIn(row.attendeeId)}>
                                  <Typography component="span" variant="body1">
                                    {x}
                                  </Typography>
                                </StyledIconButton>
                              ))}
                          </CustomIconContextMenu>
                        </StyledTableCell>
                      </CustomTableRow>
                    ))}
                  </TableBody>
                </Table>
              </InfiniteScroll>
            </CustomTableContainer>
          </Box>
        </Box>
      </Box>
    </AdminContainer>
  )
}

export default EventRegistrantsPage
